// extracted by mini-css-extract-plugin
export var button = "_k7-2";
export var card = "_k7-0";
export var closeButtonContainer = "_k7-3";
export var iconContainer = "_k7-1";